import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getAllTickets = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket`, data);
        return await response.data;
    } catch (error) {
        console.log("getAllTickets - error", error)
        return handleApiError(error)
    }
}

export const searchTickets = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/searchTickets`, data);
        return await response.data;
    } catch (error) {
        console.log("searchTickets - error", error)
        return handleApiError(error)
    }
}

export const getTicketCategories = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/ticketCategories`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketCategories - error", error)
        return handleApiError(error)
    }
}

export const getTicketSubCategories = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/ticketSubCategories`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketSubCategories - error", error)
        return handleApiError(error)
    }
}

export const getTicketStatuses = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/ticketStatus`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketStatuses - error", error)
        return handleApiError(error)
    }
}

export const addTicket = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/addticket`, data);
        return await response.data;
    } catch (error) {
        console.log("addTicket - error", error)
        return handleApiError(error)
    }
}

export const getTicketById = async (ticketData) => {
    const data = {
        ticketId: ticketData.ticketId,
        userDetails : ticketData.userDetails
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/getTicketById`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketById - error", error)
        return handleApiError(error)
    }
}

export const getTicketCommentsByTicketId = async (ticketId) => {
    const data = {
        ticketId: ticketId
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/getTicketComments`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketCommentsByTicketId - error", error)
        return handleApiError(error)
    }
}

export const updateTicketFields = async (data, id) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/ticketupdate/${id}`, data);
        return await response.data;
    } catch (error) {
        console.log("updateTicketFields - error", error)
        return handleApiError(error)
    }
}

export const addTicketComment = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/addTicketComment`, data);
        return await response.data;
    } catch (error) {
        console.log("addTicketComment - error", error)
        return handleApiError(error)
    }
}

export const getTicketGroupAssignees = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/groupAssignee`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketGroupAssignees - error", error)
        return handleApiError(error)
    }
}

export const getTicketSubCategoryParams = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/subCategoryParams`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketSubCategoryParams - error", error)
        return handleApiError(error)
    }
}

export const getBuyerCompanies = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/buyerCompanies`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerCompanies - error", error)
        return handleApiError(error)
    }
}

export const getCompanyBranchesByCompanyId = async (companyId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/buyerCompanyBranches/${companyId}`);
        return await response.data;
    } catch (error) {
        console.log("getCompanyBranchesByCompanyId - error", error)
        return handleApiError(error)
    }
}

export const getTicketConstraintAssignees = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/constraintAssignees`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketConstraintAssignees - error", error)
        return handleApiError(error)
    }
}

export const getTicketConstraintCategories = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/constraintCategories`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketConstraintCategories - error", error)
        return handleApiError(error)
    }
}

export const getFollowerList = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/follower`, data);
        return await response.data;
    } catch (error) {
        console.log("getFollowerList - error", error)
        return handleApiError(error)
    }
}

export const getTicketDetailedStatus = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/ticketDetailedStatus`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketDetailedStatus - error", error)
        return handleApiError(error)
    }
}

export const getLastcommentStructures = async (data) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/ticket/lastCommentStructure`, data);
        return await response.data;
    } catch (error) {
        console.log("getLastcommentStructures - error", error)
        return handleApiError(error)
    }
}

export const reOpenTicket = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/re-open`, data);
        return await response.data;
    } catch (error) {
        console.log("reOpenTicket - error", error)
        return handleApiError(error)
    }
}

export const getTicketVisibilityTypes = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/ticket/getTicketVisibilityTypes`, data);
        return await response.data;
    } catch (error) {
        console.log("getTicketVisibilityTypes - error", error)
        return handleApiError(error)
    }
}